import styled from 'styled-components';

import { ReferralOfferIntro, TableCell, Typography } from '@libs/components';

type ChildrenWrapperProps = {
  shouldHavePadding: boolean;
};

export const Container = styled.div`
  height: 75vh;

  overflow-x: hidden;

  ${({ theme }) => theme.media.laptop`
      height: unset;
      width: 80rem;
  `}
`;

export const BlueWrapper = styled.div`
  padding: 1.6rem 1.6rem 6.2rem 1.6rem;

  background: linear-gradient(144.31deg, #3d62d7 -16.06%, #191c7a 121.84%);
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  ${({ theme }) => theme.media.laptop`
      width: 96%;
      margin: 0 auto;
      padding: 2.4rem 2.2rem 7rem 2.2rem;
  `}
`;

export const DescriptionGlass = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const CustomReferralOfferIntro = styled(ReferralOfferIntro)`
  .texts-wrapper {
    align-items: center;
  }
`;

export const CustomImg = styled.img`
  width: 21rem;
  margin-top: 2.2rem;
  ${({ theme }) => theme.media.laptop`
      margin-top: 4.8rem;
  `}
`;

export const ReferralProgramContainer = styled.div`
  width: 100%;
  padding: 1.6rem;

  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  box-shadow: ${({ theme }) => theme.shadows.lg};

  ${({ theme }) => theme.media.laptop`
      padding: 0.8rem 0.8rem 2.4rem;
  `}
`;

export const ReferralProgramTitleWrapper = styled.div`
  width: 100%;
  padding: 1.2rem 0;
  margin-bottom: 1.6rem;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
`;

export const AssetImg = styled.img`
  height: 6.4rem;
`;

export const AssetWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 4rem;

  gap: 1.6rem;
  .sectionTitle {
    margin-left: 1.6rem;
  }
`;

export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`
  padding: ${({ shouldHavePadding }) =>
    shouldHavePadding ? '1.6rem' : '0rem'};

  text-align: start;
`;

export const CustomTableCell = styled(TableCell)`
  .cellDescription {
    align-items: end;
    flex-direction: row;
    gap: 0.8rem;
  }
`;

export const ProgramInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  box-shadow: ${({ theme }) => theme.shadows.xl3};
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x6};
  margin-top: -6rem;
  margin-bottom: 4.8rem;

  ${({ theme }) => theme.media.laptop`
       margin-top: -7rem;
       margin-left: 2.4rem;
       margin-right: 2.4rem;
        margin-bottom: 6rem;
    border-radius: ${theme.borderRadius.x12 as unknown as TemplateStringsArray};


    `};
`;

export const ProgramDescOuterWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  padding: 0.8rem;
  box-shadow: ${({ theme }) => theme.shadows.lg};

  ${({ theme }) => theme.media.laptop`
      

    `};
`;

export const ProgramDescInnerWrapper = styled.div`
  padding: 1.2rem;
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  ${({ theme }) => theme.media.tabletL`
       padding: 2.4rem;
    `};
`;

export const ProgramMobileTitle = styled(Typography)`
  text-align: center;

  ${({ theme }) => theme.media.tabletL`
       display: none
    `};
`;
export const ProgramWebTitle = styled(Typography)`
  display: none;
  ${({ theme }) => theme.media.tabletL`
        display: block;
        text-align: center;
    `};
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  padding: 1.2rem 1.8rem 1.2rem 3.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const StepIndex = styled.div`
  height: 4rem;
  width: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  left: -2rem;

  background: linear-gradient(144.31deg, #3d62d7 -16.06%, #191c7a 121.84%);
  border-radius: ${({ theme }) => theme.borderRadius.highest};
`;

export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-left: 2rem;
  div {
    background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  }
`;

export const QuestionsWrapper = styled.div``;

export const SeparatorLine = styled.div`
  margin: 1.2rem 0;
  height: 0.05rem;
  background-color: ${({ theme }) => theme.colors.text.interactive};
  width: 100%;
`;
